import moment from "moment";

export const ROUTE_ORDER_COLUMNS = [
  {
    Header: "Route Id",
    accessor: "RouteId"
  },
  {
    Header: "Route Description",
    accessor: "RouteDescription"
  },
  {
    Header: "Pickup Location Id",
    id: "PickupLocationId",
    accessor: "PickupLocation.LocationID"
  },
  {
    Header: "Pickup Location",
    id: "PickupLocation",
    accessor: "PickupLocation.LocationName"
  },
  {
    Header: "Pickup City",
    id: "PickupLocationCity",
    accessor: "PickupLocation.City"
  },
  {
    Header: "Pickup State",
    id: "PickupLocationState",
    accessor: "PickupLocation.State"
  },
  {
    Header: "Delivery Location Id",
    id: "DeliveryLocationId",
    accessor: "DeliveryLocation.LocationID"
  },
  {
    Header: "Delivery Location",
    id: "DeliveryLocationName",
    accessor: "DeliveryLocation.LocationName"
  },
  {
    Header: "Delivery City",
    id: "DeliveryLocationCity",
    accessor: "DeliveryLocation.City"
  },
  {
    Header: "Delivery State",
    id: "DeliveryLocationState",
    accessor: "DeliveryLocation.State"
  }
];

export const ROUTE_COLUMNS = [
  {
    Header: "Route Id",
    accessor: "RouteId"
  },
  {
    Header: "Customer No.",
    accessor: "Customer.CustomerNo",
    id: "CustomerNo"
  },
  {
    Header: "Customer",
    accessor: "Customer.Name",
    id: "Customer"
  },
  {
    Header: "Route Description",
    accessor: "RouteDescription"
  },
  {
    Header: "Contract",
    accessor: "Contract"
  },
  {
    Header: "Load Type",
    accessor: "LoadType.CodeDescription"
  },
  {
    Header: "Start Location Id",
    id: "StartLocationID",
    accessor: "StartLocation.LocationID"
  },
  {
    Header: "Start Location",
    id: "StartLocation",
    accessor: "StartLocation.LocationName"
  },
  {
    Header: "Pickup Location ID",
    id: "PickupLocationID",
    accessor: "PickupLocation.LocationID"
  },
  {
    Header: "Pickup Location",
    id: "PickupLocation",
    accessor: "PickupLocation.LocationName"
  },
  {
    Header: "Delivery Location ID",
    id: "DeliveryLocationID",
    accessor: "DeliveryLocation.LocationID"
  },
  {
    Header: "Delivery Location",
    id: "DeliveryLocation",
    accessor: "DeliveryLocation.LocationName"
  },
  {
    Header: "Ending Location ID",
    id: "EndingLocationID",
    accessor: "EndingLocation.LocationID"
  },
  {
    Header: "Ending Location",
    id: "EndingLocation",
    accessor: "EndingLocation.LocationName"
  },
  {
    Header: "Bill To No.",
    accessor: "BillTo.CustomerNo",
    id: "BillTo.CustomerNo"
  },
  {
    Header: "Bill To",
    accessor: "BillTo.Name",
    id: "BillTo.Name"
  },
  {
    Header: "Status",
    accessor: "Status",
    id: "Status"
  },
  {
    Header: "Industrial",
    accessor: "IndustrialFlag"
  },
  {
    Header: "Motor Oil",
    accessor: "MotorOilFlag"
  },
  {
    Header: "Loaded Miles",
    accessor: "LoadedMiles"
  },
  {
    Header: "Mileage",
    accessor: "Mileage"
  },
  {
    Header: "Charge For Tolls",
    accessor: "ChargeForTolls"
  },
  {
    Header: "Tolls",
    accessor: "Tolls"
  },
  {
    Header: "Times",
    accessor: "Times"
  },
  {
    Header: "Load Time",
    accessor: "LoadTime"
  },
  {
    Header: "Travel Time",
    accessor: "TravelTime"
  },
  {
    Header: "Unload Time",
    accessor: "UnloadTime"
  },
  {
    Header: "Return Time",
    accessor: "ReturnToTerminalTime"
  }
];

export const ROUTE_VIEW_COLUMNS = [
  {
    Header: "Customer No.",
    accessor: "CustomerNo",
    id: "CustomerNo"
  },
  {
    Header: "Customer Name",
    accessor: "CustomerName",
    id: "CustomerName"
  },
  {
    Header: "Route Id",
    accessor: "RouteId"
  },
  {
    Header: "Route Description",
    accessor: "RouteDescription"
  },
  {
    Header: "Contract",
    accessor: "Contract"
  },
  {
    Header: "Pickup Location",
    id: "PickupLocation",
    accessor: "PickupLocationID"
  },
  {
    Header: "Pickup Location Name",
    id: "PickupLocationName",
    accessor: "PickupLocationName"
  },
  {
    Header: "Pickup City",
    id: "PickupLocationCity",
    accessor: "PickupLocationCity"
  },
  {
    Header: "Pickup State",
    id: "PickupLocationState",
    accessor: "PickupLocationState"
  },
  {
    Header: "Delivery Location",
    id: "DeliveryLocation",
    accessor: "DeliveryLocationID"
  },
  {
    Header: "Delivery Location Name",
    id: "DeliveryLocationName",
    accessor: "DeliveryLocationName"
  },
  {
    Header: "Delivery City",
    id: "DeliveryLocationCity",
    accessor: "DeliveryLocationCity"
  },
  {
    Header: "Delivery State",
    id: "DeliveryLocationState",
    accessor: "DeliveryLocationState"
  },
  {
    Header: "Start Location ID",
    id: "StartLocation",
    accessor: "StartLocationID"
  },
  {
    Header: "Start Location Name",
    id: "StartLocationName",
    accessor: "StartLocationName"
  },
  {
    Header: "Ending Location",
    id: "EndingLocation",
    accessor: "EndingLocationID"
  },
  {
    Header: "Ending Location Name",
    id: "EndingLocationName",
    accessor: "EndingLocationName"
  },
  {
    Header: "Load Type",
    accessor: "LoadType"
  },
  {
    Header: "Start Date",
    accessor: "StartDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "End Date",
    accessor: "EndDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Bill To No.",
    accessor: "BillToCustomerNo",
    id: "BillToCustomerNo"
  },
  {
    Header: "Bill To",
    accessor: "BillToCustomerName",
    id: "BillToCustomerName"
  },
  {
    Header: "Status",
    accessor: "Status",
    id: "Status"
  },

  {
    Header: "Industrial",
    accessor: "IndustrialFlag"
  },
  {
    Header: "Queens",
    accessor: "MotorOilFlag"
  },
  {
    Header: "Loaded Miles",
    accessor: "LoadedMiles"
  },
  {
    Header: "Mileage",
    accessor: "Mileage"
  },
  {
    Header: "Tolls",
    accessor: "Tolls"
  },
  {
    Header: "Charge For Tolls",
    accessor: "ChargeForTolls"
  },

  {
    Header: "Times",
    accessor: "Times"
  },
  {
    Header: "Load Time",
    accessor: "LoadTime"
  },
  {
    Header: "Travel Time",
    accessor: "TravelTime"
  },
  {
    Header: "Unload Time",
    accessor: "UnloadTime"
  },
  {
    Header: "Return Time",
    accessor: "ReturnToTerminalTime"
  }
];

export const ROUTE_PRODUCT_DETAILS_COLUMNS = [
  {
    Header: "Code",
    accessor: "Product.ProductCode"
  },
  {
    Header: "Description",
    accessor: "Product.Description"
  }
];

export const ROUTE_PRODUCT_BILLING_COLUMNS = [
  {
    Header: "Code",
    accessor: "Product.ProductCode"
  },
  {
    Header: "Description",
    accessor: "Product.Description"
  },
  {
    Header: "Charge Method",
    accessor: "ChargeMethod.CodeDescription"
  },
  {
    Header: "Rate",
    accessor: "Rate",
    Cell: ({ cell }) =>
      cell.value !== null ? `$${parseFloat(cell.value).toFixed(2)}` : null
  }
];
